import $ from 'jquery';

const config = {
  win: $(window),
  dots: '.flickity-page-dots',
  slider: '.flickity-enabled',
  viewport: '.flickity-viewport',
  viewportHeight: 400,
  caption: '.caption',
  header: '.node-header',
  cell: '.carousel-cell',
  wrapper: '.caption-wrapper',
  image: 'img',
};

export default class HeroSlider {
  constructor(element) {
    this.element = element;
    this.$element = $(element);
    this.dots = $(config.dots, this.element);
    // eslint-disable-next-line prefer-destructuring
    this.flickityWrapper = $(config.slider, this.element);
    this.build();
    this.update();
    this.ready();
    window.addEventListener('resize', this.update.bind(this), { passive: true });
  }

  build() {
    $(config.cell, this.element).each((i, e) => {
      if ($(config.caption, e).text() === '') {
        $(config.wrapper, e).css('background', 'none');
      }
    });
  }

  update() {
    if (config.win.width() <= 767) {
      this.mobile();
    } else {
      this.desktop();
    }
  }

  mobile() {
    let captionHeight = 0;
    let imageHeight = 0;

    this.flickityWrapper.css('min-height', `${imageHeight}px`);
    $(config.viewport, this.element).css('height', `${imageHeight}px`);

    $(config.caption, this.element).each((i, e) => {
      if ($(e).outerHeight() < captionHeight) {
        captionHeight = $(e).outerHeight();
      }
      if ($(e).outerHeight() > captionHeight) {
        captionHeight = $(e).outerHeight();
      }
    });

    $(config.image, this.element).each((i, e) => {
      if ($(e).outerHeight() > imageHeight) {
        imageHeight = $(e).outerHeight();
      }
      if ($(e).outerHeight() < imageHeight) {
        imageHeight = $(e).outerHeight();
      }
    });

    const viewportHeight = `${imageHeight + captionHeight}px`;
    this.flickityWrapper.css('min-height', viewportHeight);
    $(config.viewport, this.element).css('height', `${imageHeight}px`);
    this.dots.css('bottom', `${captionHeight + 10}px`);
  }

  desktop() {
    const marginBottom = $(config.header, this.element).height();
    // this.dots.css('bottom', '25px');
    this.flickityWrapper.css('min-height', 'unset');
    $(config.caption, this.element).each((i, e) => {
      $(e).css('margin-bottom', marginBottom + 170);
    });
  }

  ready() {
    this.$element.addClass('ready');
  }
}
